import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Offline support: register the service worker that caches the app shell,
// API data and uploaded files so Julia AI opens with no connection.
// Auto-update: when a redeployed version is detected, the new service worker
// takes control and the app reloads once so users always run the latest code.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        // Re-check for a new version every time the app is opened / foregrounded
        const check = () => reg.update().catch(() => {});
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") check();
        });
        window.addEventListener("online", check);
      })
      .catch(() => {});

    const hadController = !!navigator.serviceWorker.controller;
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      // Skip the very first install (page is already the newest version);
      // reload exactly once when an UPDATED worker takes over.
      if (!hadController || reloaded) return;
      reloaded = true;
      // Flag for the app to show a "New version installed" toast after reload
      try {
        sessionStorage.setItem("julia_updated", "1");
      } catch (err) {
        console.warn("Could not persist update flag (private mode?)", err);
      }
      window.location.reload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
